<template>
	<div class="prior">
		<title>预约</title>
		<div v-html="textareas" style="padding:6vw;"></div>
		<div>
			<div style="padding:6vw;width: 80vw;margin:0 auto;margin-bottom:6vw;background:#e5e5e5;border-radius:6px;">
				<mt-field placeholder="姓名" v-model="form.name"></mt-field>
				<div style="height:8px;"></div>
				<mt-field type="tel" placeholder="手机号" v-model="form.phone"></mt-field>
				<div style="height:8px;"></div>
				<mt-field placeholder="地址（粗略地址）" type="textarea" rows="3" v-model="form.install_address"></mt-field>
				<div style="height:20px;"></div>
				<mt-button @click.native="prior" type="default" style="width: 100%;color:#fff;background:#666;">立即预约</mt-button>
				<div style="height:8px;"></div>
				<p style="font:14px;font-weight: bold;color:#999;white-space:nowrap;">温馨提示:</p>
				<p style="font:12px;margin-top:-4px;color:#999;white-space:nowrap;">为了给您更好的服务,请正确填写个人信息.</p>
				<!--<div style="text-align: center;color:#e9a727">
					官方网站：<a href="http://www.hooply.com" style="color:#e9a727;text-decoration:underline;">www.hooply.com</a>
				</div>-->
			</div>
		</div>
	</div>
</template>
<script>
	import { Field,Button,Toast } from 'mint-ui';
	export default {
		computed: {
			
		},
		data() {
			return {
				form:{},
				textareas:""
			}
		},
		methods: {
			prior() {
				let self=this,form=self.form
				form.user_id=this.$route.params.share_user_id?this.$route.params.share_user_id:''
				form.recommend_type=this.$route.params.share_user_id?1:0
				self.$store.dispatch('post',{u:'/appoint_lease/add',d:form}).then(function(res){
			    	if(res.err==0){
			    		Toast({
							message: '预约成功',
							iconClass: 'iconfont icon-gou'
						});
						return
			    	}
			    	Toast({
						message: res.data,
					});
				})
			},
		},
		mounted() {
			let self=this,go=window.location.href,form=self.form
			form.user_id=this.$route.params.share_user_id?this.$route.params.share_user_id:''
			self.$store.dispatch('post',{u:'/rich_cext_config/appPrior',d:form}).then(function(res){
		    	if(res.err==0){
		    		self.textareas=res.data.config_value
					return
		    	}
		    	Toast({
					message: res.data,
				});
			})
			//初始化微信分享
    		wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
				wx.updateAppMessageShareData({ 
					title:'你需要被关在门外多少次，才会觉醒……',
					desc:'让它来守护你吧',
					link:go,
					imgUrl: 'https://xhlzn.oss-cn-hangzhou.aliyuncs.com/share.jpg',
				}, function(res) {
					
				});
				wx.updateTimelineShareData({ 
					title:'你需要被关在门外多少次，才会觉醒……',
					link:go,
					imgUrl: 'https://xhlzn.oss-cn-hangzhou.aliyuncs.com/share.jpg',
				}, function(res) {
					
				});
				wx.onMenuShareAppMessage({
					title:'你需要被关在门外多少次，才会觉醒……',
					desc:'让它来守护你吧',
					link:go,
					imgUrl: 'https://xhlzn.oss-cn-hangzhou.aliyuncs.com/share.jpg',
					type: '', 
					dataUrl: '', 
					success: function () {
					// 用户点击了分享后执行的回调函数
					}
				});
				wx.onMenuShareTimeline({
					title:'你需要被关在门外多少次，才会觉醒……',
					link:go,
					imgUrl: 'https://xhlzn.oss-cn-hangzhou.aliyuncs.com/share.jpg',
					success: function () {
					// 用户点击了分享后执行的回调函数
					},
				});
			});
		}
	}
</script>
<style scoped>
	.mint-cell{
		border-radius: 6px !important;
	}
</style>
<style type="text/css">
	.prior h1{
		line-height: 1em !important;
	}
	.prior img{
		max-width: 100%;
		display: inline-block !important;
	}
</style>


// WEBPACK FOOTER //
// src/views/appPrior.vue